import Script from "next/script";

export const ScriptTag = ({ id, src, code = "", strategy = "afterInteractive" }) => {
  if (src) {
    return <Script id={id} src={src} strategy={strategy} />;
  }

  return (
    <Script
      id={id}
      strategy={strategy}
      dangerouslySetInnerHTML={{
        __html: code,
      }}
    />
  );
}

export default ScriptTag;
